import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import ExceptionIcon from 'components/exceptions/ExceptionIcon'
import { getExceptionTypeColor, getExceptionTypeLabel } from 'settings/constants/exceptionType'
import { ALPHA_38_PERCENT } from 'theme/colors'

// Body row 1: the type pill (icon + label), color from exceptionType.ts. Registry-sourced
// twin of the legacy ExceptionChip — kept local so the refreshed card owns its tokens.
type ExceptionTypeChipProps = {
  exceptionType?: string
}

const ExceptionTypeChip: React.FC<ExceptionTypeChipProps> = ({ exceptionType }) => {
  const theme = useTheme()

  return (
    <Chip
      avatar={
        <Avatar sx={{ backgroundColor: `${theme.palette.common.black}${ALPHA_38_PERCENT}` }}>
          <ExceptionIcon exception={exceptionType} sx={{ color: theme.palette.common.white, fontSize: 16 }} />
        </Avatar>
      }
      label={getExceptionTypeLabel(exceptionType)}
      size="small"
      sx={{ backgroundColor: getExceptionTypeColor(exceptionType), borderRadius: '4px' }}
    />
  )
}

export default ExceptionTypeChip
